export const getCommonStyles = theme => ({
  editorBackground: theme.palette.type === 'dark' ? '#222' : theme.palette.common.white,
  editorBorder: `2px solid ${theme.palette.primary.main}`,
  editorBorderRadius: '5px'
});
//# sourceMappingURL=styles.js.map